import { useParams } from "react-router-dom";

export function useKeyedParams<E extends object>(): E {
  return useParams() as E;
}
